import React from "react";
import withDocumentTitle from "utils/withDocumentTitle";
import { Button, Form, Footer } from "auth/components";
import { SignInLink } from "auth/Links";

const ResendConfirmation = () => (
  <Form
    action="/users/confirmation"
    title="Resend Confirmation Email"
    show_email
  >
    <Button type="submit">Send Confirmation</Button>
    <Footer>
      <SignInLink />
    </Footer>
  </Form>
);

export default withDocumentTitle("Resend Confirmation Email")(
  ResendConfirmation
);
